import { render, staticRenderFns } from "./MedicalTransmissionEdit.vue?vue&type=template&id=0e36d30f&"
import script from "./MedicalTransmissionEdit.vue?vue&type=script&lang=ts&"
export * from "./MedicalTransmissionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MedicalTransmissionEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDivider,VRow,VTab,VTabItem,VTabs,VTabsItems})
